import { Store } from '@tanstack/store'

// Load initial theme from localStorage
const storedTheme = localStorage.getItem('isDarkMode')
const StoredShowTour = localStorage.getItem('isShowTour')
const initialIsDarkMode = storedTheme === 'true' // converts string to boolean
const initialShowTour = StoredShowTour === 'true' // converts string to boolean

export const themeStore = new Store({
    isDarkMode: initialIsDarkMode,
    isShowTour: initialShowTour
})

export const setDarkMode = (value) => {
    localStorage.setItem('isDarkMode', value)
    themeStore.setState((prev) => ({
        ...prev,
        isDarkMode: value,
    }))
}

export const setShowTour = (value) => {
    localStorage.setItem('isShowTour', value)
    themeStore.setState((prev) => ({
        ...prev,
        isShowTour: value,
    }))
}